export default __webpack_public_path__ + "static/Plots0008-b374ba52619caa5fcb6f17cd4527ce31.jpg";